let ctx = null;

const ton = (frekans, sure, tip = "sine") => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = tip;
    o.frequency.value = frekans;
    g.gain.setValueAtTime(0.25, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + sure);
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + sure);
  } catch { }
};

const titret = (desen) => { try { navigator.vibrate?.(desen); } catch { } };

export const bipTamam = () => { ton(1400, 0.12); titret(70); };
export const bipHata = () => { ton(220, 0.35, "square"); titret([120, 80, 120]); };
